exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.drag-handle{position:absolute;top:50%;color:gray;width:20px;height:20px;line-height:20px;text-align:center;border-radius:100%;cursor:move;transform:translateY(-50%)\n}\n.drag-handle.right{right:-20px\n}\n.drag-handle.left{left:-20px\n}\n.drag-handle.ui-hidden{display:none\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e60f7730","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/UI/DragHandle.vue
// module id = 514
// module chunks = 0